import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'currency',
	standalone: true,
})
export class CurrencyPipe implements PipeTransform {
	transform(value: number, args = {locale: 'en-GB', currency: 'GBP'}, inPence = false): string {
		return new Intl.NumberFormat(args.locale, { style: "currency", currency: args.currency }).format(
    inPence ? value / 100 : value);
	}
}
